<template>
  <div class="conditioning-service">
    <!-- 导航栏 -->
    <header class="navbar">
      <div class="container" style="max-width: 100%;">
        <div class="logo">
          <img src="/hhwl.png" alt="北京和合网链科技有限公司" />
          <span>北京和合网链科技有限公司</span>
        </div>
        <nav class="nav-links">
          <router-link to="/" class="nav-link">首页</router-link>
          <router-link to="/health-detection" class="nav-link">健康检测</router-link>
          <router-link to="/health-management" class="nav-link">健康管理</router-link>
          <router-link to="/conditioning-service" class="nav-link" style="color: #3498db;">调理服务</router-link>
          <router-link to="/expert-team" class="nav-link">专家团队</router-link>
          <router-link to="/news" class="nav-link">行业资讯</router-link>
          <router-link to="/cases" class="nav-link">成功案例</router-link>
          <router-link to="/appointment-service" class="nav-link">预约服务</router-link>
        </nav>
        <div class="user-actions" style="width: 414.34px;"></div>
      </div>
    </header>

    <!-- 页面头部 -->
    <div class="page-header">
      <div class="header-content">
        <h1>量子调理服务</h1>
        <p>运用先进量子技术，为您量身定制个性化调理方案，重塑健康平衡</p>
        <div class="header-features">
          <span><i class="el-icon-check"></i>量子能量调理</span>
          <span><i class="el-icon-check"></i>个性化方案</span>
          <span><i class="el-icon-check"></i>专业团队</span>
        </div>
      </div>
    </div>

    <!-- 服务概述 -->
    <div class="section overview-section">
      <div class="container">
        <h2 class="section-title">服务概述</h2>
        <div class="overview-content">
          <div class="overview-text">
            <p>量子调理服务是基于量子物理学原理和生物能量医学理论开发的创新健康调理方案。通过运用量子共振技术和生物反馈系统，我们能够精准识别身体的能量失衡状态，并提供针对性的调理干预。</p>
            <p>我们的调理服务不仅关注症状的缓解，更致力于从根源上恢复身体的自然平衡状态，提升整体健康水平和生活质量。</p>
            <div class="overview-stats">
              <div class="stat-item">
                <div class="stat-number">95%</div>
                <div class="stat-label">客户满意度</div>
              </div>
              <div class="stat-item">
                <div class="stat-number">10000+</div>
                <div class="stat-label">成功案例</div>
              </div>
              <div class="stat-item">
                <div class="stat-number">15+</div>
                <div class="stat-label">调理项目</div>
              </div>
            </div>
          </div>
          <div class="overview-image">
            <img src="/api/placeholder/600/400" alt="量子调理服务">
          </div>
        </div>
      </div>
    </div>

    <!-- 核心调理项目 -->
    <div class="section services-section">
      <div class="container">
        <h2 class="section-title">核心调理项目</h2>
        <div class="services-grid">
          <div class="service-card" v-for="service in services" :key="service.id">
            <div class="service-icon">
              <i :class="service.icon"></i>
            </div>
            <h3>{{ service.title }}</h3>
            <p>{{ service.description }}</p>
            <ul class="service-features">
              <li v-for="feature in service.features" :key="feature">{{ feature }}</li>
            </ul>
            <button class="service-btn" @click="showServiceDetail(service)">了解详情</button>
          </div>
        </div>
      </div>
    </div>

    <!-- 调理原理 -->
    <div class="section principle-section">
      <div class="container">
        <h2 class="section-title">量子调理原理</h2>
        <div class="principle-content">
          <div class="principle-steps">
            <div class="step" v-for="(step, index) in principleSteps" :key="index">
              <div class="step-number">{{ index + 1 }}</div>
              <div class="step-content">
                <h3>{{ step.title }}</h3>
                <p>{{ step.description }}</p>
              </div>
            </div>
          </div>
          <div class="principle-image">
            <img src="/api/placeholder/500/300" alt="量子调理原理">
          </div>
        </div>
      </div>
    </div>

    <!-- 调理流程 -->
    <div class="section process-section">
      <div class="container">
        <h2 class="section-title">调理流程</h2>
        <div class="process-timeline">
          <div class="timeline-item" v-for="(item, index) in processItems" :key="index" @click="toggleProcessDetail(index)">
            <div class="timeline-dot">{{ index + 1 }}</div>
            <div class="timeline-content">
              <h3>{{ item.title }}</h3>
              <p>{{ item.description }}</p>
              <div class="timeline-duration">{{ item.duration }}</div>
              <div class="timeline-detail" v-if="expandedProcessIndex === index">
                <p>{{ item.detail }}</p>
                <img :src="item.image" alt="流程示意图" class="process-image">
              </div>
              <div class="timeline-expand" v-if="item.detail">
                <i class="el-icon-arrow-down" :class="{ active: expandedProcessIndex === index }"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 适用人群 -->
    <div class="section target-section">
      <div class="container">
        <h2 class="section-title">适用人群</h2>
        <div class="target-groups">
          <div class="target-card" v-for="group in targetGroups" :key="group.id">
            <div class="target-icon">
              <i :class="group.icon"></i>
            </div>
            <h3>{{ group.title }}</h3>
            <p>{{ group.description }}</p>
            <div class="target-symptoms">
              <span v-for="symptom in group.symptoms" :key="symptom">{{ symptom }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 技术优势 -->
    <div class="section advantages-section">
      <div class="container">
        <h2 class="section-title">技术优势</h2>
        <div class="advantages-grid">
          <div class="advantage-item" v-for="advantage in advantages" :key="advantage.id">
            <div class="advantage-icon">
              <i :class="advantage.icon"></i>
            </div>
            <h3>{{ advantage.title }}</h3>
            <p>{{ advantage.description }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 调理效果 -->
    <div class="section effects-section">
      <div class="container">
        <h2 class="section-title">调理效果</h2>
        <div class="effects-content">
          <div class="effects-chart">
            <h3>调理效果统计</h3>
            <div class="chart-item" v-for="effect in effects" :key="effect.item">
              <div class="chart-label">{{ effect.item }}</div>
              <div class="chart-bar">
                <div class="chart-progress" :style="{ width: effect.percentage + '%' }"></div>
              </div>
              <div class="chart-value">{{ effect.percentage }}%</div>
            </div>
          </div>
          <div class="effects-testimonials">
            <h3>客户反馈</h3>
            <div class="testimonial-item" v-for="testimonial in testimonials" :key="testimonial.id">
              <div class="testimonial-content">
                <p>"{{ testimonial.content }}"</p>
                <div class="testimonial-author">
                  <strong>{{ testimonial.name }}</strong>
                  <span>{{ testimonial.role }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 调理套餐 -->
    <div class="section packages-section">
      <div class="container">
        <h2 class="section-title">调理套餐</h2>
        <div class="packages-grid">
          <div class="package-card" v-for="pkg in packages" :key="pkg.id" :class="{ featured: pkg.featured }">
            <div class="package-header">
              <h3>{{ pkg.name }}</h3>
              <div class="package-price">
                <span class="price-symbol">¥</span>
                <span class="price-amount">{{ pkg.price }}</span>
                <span class="price-unit">{{ pkg.unit }}</span>
              </div>
            </div>
            <div class="package-content">
              <ul class="package-features">
                <li v-for="feature in pkg.features" :key="feature">
                  <i class="el-icon-check"></i>
                  {{ feature }}
                </li>
              </ul>
              <button class="package-btn" @click="selectPackage(pkg)">{{ pkg.buttonText }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 预约调理 -->
    <div class="section booking-section">
      <div class="container">
        <h2 class="section-title">预约调理服务</h2>
        <div class="booking-content">
          <div class="booking-form">
            <el-form :model="bookingForm" :rules="bookingRules" ref="bookingForm" label-width="100px">
              <el-form-item label="姓名" prop="name">
                <el-input v-model="bookingForm.name" placeholder="请输入您的姓名"></el-input>
              </el-form-item>
              <el-form-item label="联系电话" prop="phone">
                <el-input v-model="bookingForm.phone" placeholder="请输入您的联系电话"></el-input>
              </el-form-item>
              <el-form-item label="调理项目" prop="service">
                <el-select v-model="bookingForm.service" placeholder="请选择调理项目">
                  <el-option v-for="service in services" :key="service.id" :label="service.title" :value="service.title"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="预约时间" prop="date">
                <el-date-picker
                  v-model="bookingForm.date"
                  type="datetime"
                  placeholder="选择预约时间"
                  format="yyyy-MM-dd HH:mm"
                  value-format="yyyy-MM-dd HH:mm">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="健康状况" prop="health">
                <el-input type="textarea" v-model="bookingForm.health" :rows="3" placeholder="请简要描述您的健康状况或调理需求"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="submitBooking">提交预约</el-button>
                <el-button @click="resetForm">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div class="booking-info">
            <h3>预约须知</h3>
            <ul>
              <li>请提前24小时预约，以便我们为您安排专业调理师</li>
              <li>首次调理前请进行量子健康检测，以便制定个性化方案</li>
              <li>调理当天请穿着宽松舒适的服装</li>
              <li>调理前避免过量饮食和剧烈运动</li>
              <li>如需取消预约，请提前6小时通知我们</li>
            </ul>
            <div class="contact-info">
              <h4>咨询电话</h4>
              <p>400-888-9999</p>
              <h4>服务时间</h4>
              <p>周一至周日 9:00-21:00</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 常见问题 -->
    <div class="section faq-section">
      <div class="container">
        <h2 class="section-title">常见问题</h2>
        <div class="faq-list">
          <div class="faq-item" v-for="(faq, index) in faqs" :key="index">
            <div class="faq-question" @click="toggleFaq(index)">
              <h3>{{ faq.question }}</h3>
              <i class="el-icon-arrow-right" :class="{ active: faq.open }"></i>
            </div>
            <div class="faq-answer" v-show="faq.open">
              <p>{{ faq.answer }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 页面底部 -->
    <footer class="footer">
      <div class="container">
        <div class="footer-content">
          <div class="footer-info">
            <h3>北京和合网链科技有限公司</h3>
            <p>专注健康科技，守护您的健康</p>
            <div class="contact-info">
              <p><i class="el-icon-location"></i> 地址：北京市丰台区南三环西路91号院1号楼14层1单元1706</p>
              <p><i class="el-icon-phone"></i> 电话：15383753755</p>
              <p><i class="el-icon-message"></i> 邮箱：james@tssen.com</p>
            </div>
          </div>
          <div class="footer-links-group">
            <div class="footer-links">
              <h4>快速导航</h4>
              <a href="#home">首页</a>
              <a href="#about">关于我们</a>
              <a href="#services">服务介绍</a>
              <a href="#contact">联系我们</a>
            </div>
            <div class="footer-services">
              <h4>服务项目</h4>
              <a href="#">健康检测</a>
              <a href="#">专家咨询</a>
              <a href="#">健康管理</a>
              <a href="#">调理服务</a>
            </div>
            <div class="footer-social">
              <h4>关注我们</h4>
              <div class="social-icons">
                <a href="#" class="social-icon"><i class="el-icon-chat-line-square"></i> 微信公众号</a>
                <a href="#" class="social-icon"><i class="el-icon-message-solid"></i> 官方客服</a>
              </div>
            </div>
          </div>
        </div>
        <div class="footer-bottom">
          <div class="copyright">
            <p style="font-size: 12px;">© 2025 北京和合网链科技发展有限公司 版权所有 | 冀ICP备14010297号 | 冀ICP备14010297号-2 | 域名：tssen.com</p>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'ConditioningService',
  data() {
    return {
      phone:null,
      expandedProcessIndex: null,
      services: [
        {
          id: 1,
          title: '量子能量调理',
          icon: 'el-icon-lightning',
          description: '运用量子共振技术，调节身体能量场，恢复生命活力',
          features: ['能量平衡调节', '经络疏通', '气血调理', '免疫力提升']
        },
        {
          id: 2,
          title: '量子细胞修复',
          icon: 'el-icon-magic-stick',
          description: '通过量子频率激活细胞自我修复能力，延缓衰老',
          features: ['细胞活化', 'DNA修复', '抗氧化', '再生能力提升']
        },
        {
          id: 3,
          title: '量子情绪调理',
          icon: 'el-icon-heart',
          description: '调节情绪能量频率，缓解压力，改善心理健康',
          features: ['压力释放', '情绪平衡', '睡眠改善', '焦虑缓解']
        },
        {
          id: 4,
          title: '量子排毒调理',
          icon: 'el-icon-refresh',
          description: '促进体内毒素排出，净化身体内环境',
          features: ['肝脏排毒', '肠道净化', '重金属排除', '代谢优化']
        },
        {
          id: 5,
          title: '量子疼痛调理',
          icon: 'el-icon-first-aid-kit',
          description: '非侵入性疼痛管理，快速缓解各种急慢性疼痛',
          features: ['疼痛缓解', '炎症消除', '组织修复', '功能恢复']
        },
        {
          id: 6,
          title: '量子美容调理',
          icon: 'el-icon-star-on',
          description: '从内而外改善肌肤状态，重现青春光彩',
          features: ['肌肤紧致', '皱纹淡化', '色斑消除', '容光焕发']
        }
      ],
      principleSteps: [
        {
          title: '量子检测',
          description: '运用量子共振设备检测身体能量场状态，识别失衡区域'
        },
        {
          title: '频率分析',
          description: '分析检测数据，确定需要调理的频率和强度'
        },
        {
          title: '能量调节',
          description: '通过量子设备发射特定频率，调节身体能量场'
        },
        {
          title: '效果监测',
          description: '实时监测调理效果，及时调整调理方案'
        }
      ],
      processItems: [
        {
          title: '健康评估',
          description: '全面的健康状况评估和量子检测',
          duration: '30-60分钟',
          detail: '通过量子共振设备检测身体各器官的能量场状态，分析潜在健康风险，为后续调理提供科学依据。检测包括经络能量、细胞活性、代谢水平等多个维度。',
          image: '/api/placeholder/400/250'
        },
        {
          title: '方案制定',
          description: '根据检测结果制定个性化调理方案',
          duration: '20-30分钟',
          detail: '专业调理师根据检测结果和客户具体情况，量身定制调理方案。方案包括调理频率、强度、时长等参数，确保调理效果最大化。',
          image: '/api/placeholder/400/250'
        },
        {
          title: '调理实施',
          description: '专业调理师进行量子调理服务',
          duration: '60-90分钟',
          detail: '在舒适的环境中，使用先进的量子调理设备进行调理。调理过程无痛无创，客户只需放松身心，享受调理带来的舒适体验。',
          image: '/api/placeholder/400/250'
        },
        {
          title: '效果评估',
          description: '调理后效果评估和后续建议',
          duration: '15-20分钟',
          detail: '调理完成后，再次进行量子检测，对比调理前后的数据变化，评估调理效果。根据评估结果调整后续调理方案，并提供健康生活建议。',
          image: '/api/placeholder/400/250'
        },
        {
          title: '跟踪随访',
          description: '定期跟踪调理效果，调整方案',
          duration: '持续进行',
          detail: '建立个人健康档案，定期跟踪调理效果。通过电话、微信等方式进行随访，及时了解身体状况变化，确保调理效果的持久性。',
          image: '/api/placeholder/400/250'
        }
      ],
      targetGroups: [
        {
          id: 1,
          title: '亚健康人群',
          icon: 'el-icon-user',
          description: '长期处于亚健康状态，需要全面调理的人群',
          symptoms: ['疲劳乏力', '失眠多梦', '注意力不集中', '免疫力低下']
        },
        {
          id: 2,
          title: '慢性病患者',
          icon: 'el-icon-warning',
          description: '患有各种慢性疾病，需要辅助调理的人群',
          symptoms: ['高血压', '糖尿病', '关节炎', '消化不良']
        },
        {
          id: 3,
          title: '中老年人群',
          icon: 'el-icon-time',
          description: '进入中老年，需要抗衰老和健康维护的人群',
          symptoms: ['体力下降', '记忆力减退', '关节疼痛', '睡眠质量差']
        },
        {
          id: 4,
          title: '职场高压人群',
          icon: 'el-icon-office-building',
          description: '工作压力大，需要身心调理的职场人士',
          symptoms: ['压力过大', '焦虑紧张', '头痛头晕', '情绪波动']
        }
      ],
      advantages: [
        {
          id: 1,
          icon: 'el-icon-cpu',
          title: '先进技术',
          description: '采用国际领先的量子调理设备和技术'
        },
        {
          id: 2,
          icon: 'el-icon-user-solid',
          title: '专业团队',
          description: '资深量子调理师团队，经验丰富'
        },
        {
          id: 3,
          icon: 'el-icon-data-analysis',
          title: '精准调理',
          description: '基于量子检测数据的精准个性化调理'
        },
        {
          id: 4,
          icon: 'el-icon-circle-check',
          title: '安全无创',
          description: '非侵入性调理，无副作用，安全可靠'
        },
        {
          id: 5,
          icon: 'el-icon-timer',
          title: '快速见效',
          description: '调理效果显著，多数客户1-3次见效'
        },
        {
          id: 6,
          icon: 'el-icon-medal',
          title: '持续效果',
          description: '调理效果持久，从根本上改善健康状况'
        }
      ],
      effects: [
        { item: '睡眠质量改善', percentage: 92 },
        { item: '疲劳感缓解', percentage: 88 },
        { item: '疼痛减轻', percentage: 85 },
        { item: '情绪状态改善', percentage: 83 },
        { item: '免疫力提升', percentage: 78 },
        { item: '整体健康提升', percentage: 90 }
      ],
      testimonials: [
        {
          id: 1,
          content: '经过量子调理后，我的睡眠质量明显改善，精神状态也比以前好多了。',
          name: '张女士',
          role: '公司白领'
        },
        {
          id: 2,
          content: '长期的颈椎疼痛问题得到了很好的缓解，现在工作效率都提高了。',
          name: '李先生',
          role: 'IT工程师'
        },
        {
          id: 3,
          content: '量子调理帮助我缓解了更年期症状，生活质量得到了很大提升。',
          name: '王女士',
          role: '教师'
        }
      ],
      packages: [
        {
          id: 1,
          name: '体验套餐',
          price: 299,
          unit: '次',
          features: [
            '量子健康检测',
            '单项调理服务',
            '调理效果评估',
            '健康建议指导'
          ],
          buttonText: '立即体验',
          featured: false
        },
        {
          id: 2,
          name: '标准套餐',
          price: 1299,
          unit: '5次',
          features: [
            '全面量子检测',
            '多项调理服务',
            '个性化调理方案',
            '定期效果评估',
            '健康跟踪服务',
            '营养指导建议'
          ],
          buttonText: '选择套餐',
          featured: true
        },
        {
          id: 3,
          name: 'VIP套餐',
          price: 4999,
          unit: '月',
          features: [
            '无限次量子检测',
            '全套调理服务',
            '专属调理方案',
            '24小时健康咨询',
            '上门调理服务',
            '专家团队会诊',
            '详细健康报告'
          ],
          buttonText: 'VIP专享',
          featured: false
        }
      ],
      bookingForm: {
        name: '',
        phone: '',
        service: '',
        date: '',
        health: ''
      },
      bookingRules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ],
        service: [
          { required: true, message: '请选择调理项目', trigger: 'change' }
        ],
        date: [
          { required: true, message: '请选择预约时间', trigger: 'change' }
        ]
      },
      faqs: [
        {
          question: '量子调理服务安全吗？',
          answer: '量子调理服务是完全安全的，采用非侵入性技术，无任何副作用。所有设备都经过国际认证，调理师都经过专业培训。',
          open: false
        },
        {
          question: '调理一次需要多长时间？',
          answer: '单次调理时间通常为60-90分钟，加上前后的检测和评估，总共需要约2小时。',
          open: false
        },
        {
          question: '多少次调理能看到效果？',
          answer: '因人而异，大多数客户在1-3次调理后就能感受到明显改善。建议按疗程进行调理以获得最佳效果。',
          open: false
        },
        {
          question: '调理期间有什么注意事项？',
          answer: '调理期间建议保持充足睡眠，均衡饮食，适量运动，避免过度劳累。同时要保持良好的心态，配合调理师的指导。',
          open: false
        },
        {
          question: '量子调理和传统中医有什么区别？',
          answer: '量子调理是基于现代量子物理学和生物能量医学的理论，通过调节身体能量场来达到调理目的。它与传统中医可以相互补充，共同促进健康。',
          open: false
        }
      ]
    }
  },
  methods: {
    
    reservationPromptClick() {
      if (!this.phone) {
        this.login = true
        return
      } else {
        this.reservationPrompt = true
      }
    },
    toggleProcessDetail(index) {
      this.expandedProcessIndex = this.expandedProcessIndex === index ? null : index
    },
    showServiceDetail(service) {
      // 跳转到调理服务详情页面
      this.$router.push({
        path: '/conditioning-service-detail',
        query: { id: service.id }
      })
    },
    selectPackage(pkg) {
      // 滚动到预约表单区域并预选套餐
      this.bookingForm.service = pkg.name
      this.$nextTick(() => {
        const bookingSection = document.querySelector('.booking-section')
        if (bookingSection) {
          bookingSection.scrollIntoView({ behavior: 'smooth' })
        }
      })
      this.$message.success(`已选择${pkg.name}，请填写预约信息`)
    },
    submitBooking() {
      this.$refs.bookingForm.validate((valid) => {
        if (valid) {
          this.$message.success('预约提交成功！我们会尽快与您联系确认。')
          this.resetForm()
        } else {
          this.$message.error('请完善预约信息')
          return false
        }
      })
    },
    resetForm() {
      this.$refs.bookingForm.resetFields()
    },
    toggleFaq(index) {
      this.faqs[index].open = !this.faqs[index].open
    }
  }
}
</script>

<style  lang="scss" scoped>
/* 导航栏样式 */
.navbar {
  background-color: rgba(255, 255, 255, 0.95);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  transition: all 0.3s ease;
}

.navbar {
  padding: 0 20px;
}

.navbar .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0;
  width: 100%;
}

.logo {
  width: 414.34px;
  display: flex;
  align-items: center;
  font-size: 1.2rem;
  font-weight: bold;
  color: #2c3e50;
  
  img {
    height: 40px;
    margin-right: 8px;
  }
}

.nav-links {
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  flex: 1;
  flex-wrap: wrap;
  padding: 0.5rem 1rem;
  align-items: center;
  
  a, .nav-link {
    color: #2c3e50;
    text-decoration: none;
    font-weight: 500;
    transition: all 0.3s ease;
    padding: 0.5rem 0;
    position: relative;
    white-space: nowrap;
    font-size: 0.95rem;
    cursor: pointer;
    
    &:hover,
    &.active,
    &.router-link-exact-active {
      color: #3498db;
    }
    
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 0;
      height: 2px;
      background-color: #3498db;
      transition: width 0.3s ease;
    }
    
    &:hover::after,
    &.active::after {
      width: 100%;
    }
    
    &.btn-accent {
      background-color: #3498db;
      color: white;
      padding: 0.6rem 1.8rem;
      border-radius: 25px;
      font-weight: 600;
      box-shadow: 0 2px 8px rgba(52, 152, 219, 0.3);
      
      &:hover {
        background-color: #2980b9;
        color: white;
        box-shadow: 0 4px 12px rgba(41, 128, 185, 0.4);
        transform: translateY(-1px);
      }
      
      &::after {
        display: none;
      }
    }
  }
}

.user-actions {
  display: flex;
  gap: 1rem;
  align-items: center;
  margin-left: auto;
}

.user-actions .login-btn {
  margin-left: auto;
}

.nav-btn {
  background: none;
  border: none;
  color: #2c3e50;
  cursor: pointer;
  font-weight: 500;
  transition: color 0.3s ease;
  
  &:hover {
    color: #3498db;
  }
}

.login-btn {
  background-color: #3498db;
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  
  &:hover {
    background-color: #2980b9;
    color: white;
  }
}

.conditioning-service {
  padding-top: 80px;
}

.page-header {
  background: linear-gradient(135deg, #1890FF 0%, #00D4FF 100%);
  color: white;
  padding: 80px 0;
  text-align: center;
}

.header-content h1 {
  font-size: 48px;
  margin-bottom: 20px;
  font-weight: 600;
}

.header-content p {
  font-size: 20px;
  margin-bottom: 30px;
  opacity: 0.9;
}

.header-features {
  display: flex;
  justify-content: center;
  gap: 30px;
}

.header-features span {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
}

.section {
  padding: 80px 0;
}

.section:nth-child(even) {
  background: #f8f9fa;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.section-title {
  text-align: center;
  font-size: 36px;
  margin-bottom: 60px;
  color: #333;
  font-weight: 600;
}

.overview-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;
}

.overview-text p {
  font-size: 16px;
  line-height: 1.8;
  margin-bottom: 20px;
  color: #666;
}

.overview-stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  margin-top: 40px;
}

.stat-item {
  text-align: center;
}

.stat-number {
  font-size: 36px;
  font-weight: bold;
  color: #1890FF;
  margin-bottom: 10px;
}

.stat-label {
  font-size: 14px;
  color: #666;
}

.overview-image img {
  width: 100%;
  border-radius: 10px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.1);
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 30px;
}

.service-card {
  background: white;
  padding: 40px;
  border-radius: 10px;
  box-shadow: 0 5px 20px rgba(0,0,0,0.08);
  text-align: center;
  transition: transform 0.3s ease;
}

.service-card:hover {
  transform: translateY(-5px);
}

.service-icon {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #1890FF, #00D4FF);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
}

.service-icon i {
  font-size: 36px;
  color: white;
}

.service-card h3 {
  font-size: 24px;
  margin-bottom: 15px;
  color: #333;
}

.service-card p {
  color: #666;
  margin-bottom: 20px;
  line-height: 1.6;
}

.service-features {
  list-style: none;
  padding: 0;
  margin-bottom: 30px;
}

.service-features li {
  padding: 5px 0;
  color: #666;
  font-size: 14px;
}

.service-features li:before {
  content: "✓";
  color: #1890FF;
  font-weight: bold;
  margin-right: 8px;
}

.service-btn {
  background: #1890FF;
  color: white;
  border: none;
  padding: 12px 30px;
  border-radius: 25px;
  cursor: pointer;
  font-size: 16px;
  transition: background 0.3s ease;
}

.service-btn:hover {
  background: #40a9ff;
}

.principle-content {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 60px;
  align-items: center;
}

.principle-steps {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.step {
  display: flex;
  align-items: flex-start;
  gap: 20px;
}

.step-number {
  width: 50px;
  height: 50px;
  background: #1890FF;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  font-weight: bold;
  flex-shrink: 0;
}

.step-content h3 {
  font-size: 20px;
  margin-bottom: 10px;
  color: #333;
}

.step-content p {
  color: #666;
  line-height: 1.6;
}

.principle-image img {
  width: 100%;
  border-radius: 10px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.1);
}

.process-timeline {
  position: relative;
  max-width: 800px;
  margin: 0 auto;
}

.timeline-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 60px;
  position: relative;
}

.timeline-item:not(:last-child)::after {
  content: '';
  position: absolute;
  left: 25px;
  top: 50px;
  width: 2px;
  height: 60px;
  background: #e0e0e0;
}

.timeline-dot {
  width: 50px;
  height: 50px;
  background: #1890FF;
  border-radius: 50%;
  margin-right: 30px;
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
  font-size: 18px;
}

.timeline-content {
  flex: 1;
  background: white;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 5px 20px rgba(0,0,0,0.08);
}

.timeline-content h3 {
  font-size: 20px;
  margin-bottom: 10px;
  color: #333;
}

.timeline-content p {
  color: #666;
  line-height: 1.6;
  margin-bottom: 10px;
}

.timeline-duration {
  color: #1890FF;
  font-weight: 500;
  margin-bottom: 15px;
}

.timeline-item {
  cursor: pointer;
  transition: transform 0.3s ease;
}

.timeline-item:hover {
  transform: translateX(5px);
}

.timeline-expand {
  position: absolute;
  top: 30px;
  right: 30px;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f8ff;
  border-radius: 50%;
  transition: all 0.3s ease;
}

.timeline-expand i {
  color: #1890FF;
  font-size: 16px;
  transition: transform 0.3s ease;
}

.timeline-expand i.active {
  transform: rotate(180deg);
}

.timeline-detail {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #e0e0e0;
}

.timeline-detail p {
  color: #666;
  line-height: 1.6;
  margin-bottom: 15px;
}

.process-image {
  width: 100%;
  max-width: 400px;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

.target-groups {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 30px;
}

.target-card {
  background: white;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 5px 20px rgba(0,0,0,0.08);
  text-align: center;
}

.target-icon {
  width: 70px;
  height: 70px;
  background: linear-gradient(135deg, #1890FF, #00D4FF);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
}

.target-icon i {
  font-size: 32px;
  color: white;
}

.target-card h3 {
  font-size: 20px;
  margin-bottom: 15px;
  color: #333;
}

.target-card p {
  color: #666;
  line-height: 1.6;
  margin-bottom: 20px;
}

.target-symptoms {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: center;
}

.target-symptoms span {
  background: #f0f8ff;
  color: #1890FF;
  padding: 5px 12px;
  border-radius: 15px;
  font-size: 12px;
}

.advantages-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
}

.advantage-item {
  text-align: center;
  padding: 30px;
}

.advantage-icon {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #1890FF, #00D4FF);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
}

.advantage-icon i {
  font-size: 36px;
  color: white;
}

.advantage-item h3 {
  font-size: 20px;
  margin-bottom: 15px;
  color: #333;
}

.advantage-item p {
  color: #666;
  line-height: 1.6;
}

.effects-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
}

.effects-chart h3,
.effects-testimonials h3 {
  font-size: 24px;
  margin-bottom: 30px;
  color: #333;
}

.chart-item {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  gap: 15px;
}

.chart-label {
  width: 120px;
  font-size: 14px;
  color: #666;
}

.chart-bar {
  flex: 1;
  height: 20px;
  background: #f0f0f0;
  border-radius: 10px;
  overflow: hidden;
}

.chart-progress {
  height: 100%;
  background: linear-gradient(90deg, #1890FF, #00D4FF);
  border-radius: 10px;
  transition: width 0.3s ease;
}

.chart-value {
  width: 50px;
  text-align: right;
  font-weight: bold;
  color: #1890FF;
}

.testimonial-item {
  background: #f8f9fa;
  padding: 25px;
  border-radius: 10px;
  margin-bottom: 20px;
}

.testimonial-content p {
  font-style: italic;
  margin-bottom: 15px;
  color: #666;
  line-height: 1.6;
}

.testimonial-author strong {
  color: #333;
  margin-right: 10px;
}

.testimonial-author span {
  color: #999;
  font-size: 14px;
}

.packages-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
}

.package-card {
  background: white;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 5px 20px rgba(0,0,0,0.08);
  transition: transform 0.3s ease;
}

.package-card:hover {
  transform: translateY(-5px);
}

.package-card.featured {
  transform: scale(1.05);
  box-shadow: 0 15px 40px rgba(24,144,255,0.2);
}

.package-header {
  background: linear-gradient(135deg, #1890FF, #00D4FF);
  color: white;
  padding: 40px 30px;
  text-align: center;
}

.package-header h3 {
  font-size: 28px;
  margin-bottom: 20px;
}

.package-price {
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 5px;
}

.price-symbol {
  font-size: 20px;
}

.price-amount {
  font-size: 48px;
  font-weight: bold;
}

.price-unit {
  font-size: 16px;
}

.package-content {
  padding: 30px;
}

.package-features {
  list-style: none;
  padding: 0;
  margin-bottom: 30px;
}

.package-features li {
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f0;
  color: #666;
  display: flex;
  align-items: center;
  gap: 10px;
}

.package-features li:last-child {
  border-bottom: none;
}

.package-features li i {
  color: #1890FF;
}

.package-btn {
  width: 100%;
  background: #1890FF;
  color: white;
  border: none;
  padding: 15px;
  border-radius: 25px;
  cursor: pointer;
  font-size: 16px;
  transition: background 0.3s ease;
}

.package-btn:hover {
  background: #40a9ff;
}

.booking-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
}

.booking-form {
  background: white;
  padding: 40px;
  border-radius: 10px;
  box-shadow: 0 5px 20px rgba(0,0,0,0.08);
}

/* 统一输入框大小 */
.booking-form .el-input {
  width: 100%;
}

.booking-form .el-select {
  width: 100%;
}

.booking-form .el-date-picker {
  width: 100%;
}

.booking-info {
  background: #f8f9fa;
  padding: 40px;
  border-radius: 10px;
}

.booking-info h3 {
  font-size: 24px;
  margin-bottom: 20px;
  color: #333;
}

.booking-info ul {
  list-style: none;
  padding: 0;
  margin-bottom: 30px;
}

.booking-info li {
  padding: 10px 0;
  color: #666;
  position: relative;
  padding-left: 20px;
}

.booking-info li:before {
  content: "•";
  color: #1890FF;
  position: absolute;
  left: 0;
  font-weight: bold;
}

.contact-info h4 {
  font-size: 18px;
  margin-bottom: 10px;
  color: #333;
}

.contact-info p {
  color: #1890FF;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 20px;
}

.faq-list {
  max-width: 800px;
  margin: 0 auto;
}

.faq-item {
  background: white;
  margin-bottom: 20px;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 5px 20px rgba(0,0,0,0.08);
}

.faq-question {
  padding: 25px 30px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: background 0.3s ease;
}

.faq-question:hover {
  background: #f8f9fa;
}

.faq-question h3 {
  font-size: 18px;
  color: #333;
  margin: 0;
}

.faq-question i {
  font-size: 20px;
  color: #1890FF;
  transition: transform 0.3s ease;
}

.faq-question i.active {
  transform: rotate(90deg);
}

.faq-answer {
  padding: 0 30px 25px;
  border-top: 1px solid #f0f0f0;
}

.faq-answer p {
  color: #666;
  line-height: 1.6;
  margin: 0;
}

@media (max-width: 768px) {
  .header-content h1 {
    font-size: 32px;
  }
  
  .header-features {
    flex-direction: column;
    gap: 15px;
  }
  
  .overview-content,
  .principle-content,
  .effects-content,
  .booking-content {
    grid-template-columns: 1fr;
    gap: 40px;
  }
  
  .services-grid,
  .target-groups,
  .advantages-grid {
    grid-template-columns: 1fr;
  }
  
  .packages-grid {
    grid-template-columns: 1fr;
  }
  
  .package-card.featured {
    transform: none;
  }
}

/* 页面底部样式 */
.footer {
  background-color: #263238;
  color: white;
  padding: 3rem 0 1rem;
  
  .footer-content {
    display: grid;
    grid-template-columns: 0.4fr 0.6fr;
    gap: 3rem;
    margin-bottom: 2rem;
  }
  
  .footer-links-group {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2rem;
  }
  
  .footer-info h3 {
    font-size: 1.5rem;
    margin-bottom: 1.5rem;
    color: #fff;
  }
  
  .footer-info p {
    margin-bottom: 0.8rem;
    color: rgba(255, 255, 255, 0.8);
  }
  
  .contact-info {
    margin-top: 1rem;
  }
  
  .contact-info p {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 0.9rem;
  }
  
  .footer-links, .footer-services, .footer-social {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
  
  .footer-links h4, .footer-services h4, .footer-social h4 {
    font-size: 1.2rem;
    margin-bottom: 0.5rem;
    color: #fff;
    position: relative;
    padding-bottom: 8px;
    
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 40px;
      height: 2px;
      background-color: #3498db;
    }
  }
  
  .footer-links a, .footer-services a, .footer-social a {
    color: rgba(255, 255, 255, 0.8);
    text-decoration: none;
    transition: all 0.3s ease;
    font-size: 0.9rem;
    
    &:hover {
      color: #3498db;
      padding-left: 5px;
    }
  }
  
  .social-icons {
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
  }
  
  .social-icon {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  
  .footer-bottom {
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    padding-top: 1rem;
    text-align: center;
  }
  
  .copyright {
    opacity: 0.8;
  }
  
  .copyright p {
    margin: 0;
    font-size: 12px;
  }
}
</style>